export default __webpack_public_path__ + "static/media/goldenvisa.19260550.avif";